<template>
    <g>
        <path fill-rule="evenodd" clip-rule="evenodd" d="M14 15H23.5V17H14V15Z" fill="white"/>
        <path fill-rule="evenodd" clip-rule="evenodd" d="M14 10H23.5V12H14V10Z" fill="white"/>
        <path fill-rule="evenodd" clip-rule="evenodd" d="M14 20H23.5V22H14V20Z" fill="white"/>
        <path d="M11 11C11 11.5523 10.5523 12 10 12C9.44772 12 9 11.5523 9 11C9 10.4477 9.44772 10 10 10C10.5523 10 11 10.4477 11 11Z" fill="white"/>
        <path d="M11 16C11 16.5523 10.5523 17 10 17C9.44772 17 9 16.5523 9 16C9 15.4477 9.44772 15 10 15C10.5523 15 11 15.4477 11 16Z" fill="white"/>
        <path d="M11 21C11 21.5523 10.5523 22 10 22C9.44772 22 9 21.5523 9 21C9 20.4477 9.44772 20 10 20C10.5523 20 11 20.4477 11 21Z" fill="white"/>
    </g>
</template>
